function toggleMenu(event) {
  const element = document.querySelectorAll('[data-menu]');

  element.forEach((el) => {
    el.classList.toggle('is-active');
    document.body.classList.toggle('is-active');
  });
}

function scrollEvents() {
  const header = document.querySelector('.js-header-sticky');
  const container = document.querySelector('.sng-disney-special').getBoundingClientRect();
  const headerInner = document.querySelector('#mainHeader:not([data-magellan-expedition-clone])');
  const headerInnerLocal = document.querySelector('#main-navigation-nav');
  if ((headerInner && headerInner.style.position === 'fixed' && container.y < 0)
  || (headerInnerLocal && headerInnerLocal.classList.contains('css-nloddf') && container.y < 0)) {
    if (headerInner) {
      header.style.top = `${headerInner.getBoundingClientRect().height}px`;
    } else {
      header.style.top = `${headerInnerLocal.getBoundingClientRect().height}px`;
    }
  } else {
    header.style.top = '0px';
  }
  if (container.y < 0) {
    header.classList.add('is-sticky');
  } else {
    header.classList.remove('is-sticky');
  }

  const links = document.querySelectorAll('[id^=link-]');
  links.forEach((el) => {
    const offset = el.getBoundingClientRect();
    if (offset.top - 200 < (window.innerHeight || document.documentElement.clientHeight)) {
      const id = el.getAttribute('id');
      document.querySelector('.js-header-sticky a.is-active').classList.remove('is-active');
      document.querySelector(`.js-header-sticky a[href="#${id}"`).classList.add('is-active');
    }

    if (container.y > -150) {
      document.querySelector('.js-header-sticky a.is-active').classList.remove('is-active');
      document.querySelector('.js-header-sticky a[href="#link-synopsis"').classList.add('is-active');
    }
  });
}

function init() {
  const toggleElements = document.querySelectorAll('[data-toogle-menu]');
  if (toggleElements) {
    toggleElements.forEach((el) => {
      el.addEventListener('click', toggleMenu);
    });
  }

  const itemElements = document.querySelectorAll('.js-nav-item');
  if (itemElements) {
    itemElements.forEach((el) => {
      el.addEventListener('click', toggleMenu);
    });
  }

  const headerSticky = document.querySelector('.js-header-sticky');
  if (headerSticky) {
    document.addEventListener('scroll', scrollEvents);
  }
}

export default init();
